import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../../../../src/index.css'; 

const ProgressCircle = () => {
    
const percentage = 30; 
const percentage2 = 45;  
const percentage3 = 75;  
  return (
    <div className='flex space-x-7 overflow-x-scroll max-w-screen scroll-container'>
        {/**Tarjeta de porcentaje de planta */}
        <div className="flex mt-3 space-x-32 bg-white p-6 rounded-lg shadow-lg items-center w-[393px] ">
            <div className='space-y-2 '>
                <p className='font-itcmedium text-[16px] text-[#2F2F3B]'>Malabrigo</p>
                <p className='font-itcmedium text-[22px] text-[#2F2F3B]'>150</p>
                <p className='font-itcmedium text-[12px] text-[#52526CCC] w-[125px]'>Registro de Vehículos</p>
            </div>
            
            <div className='space-y-1'>
                <div className="flex justify-end items-center ">
                    <div style={{ width: 76, height: 76 }}>
                        <svg style={{ height: 0 }}>
                            <defs>
                                <linearGradient id="gradient" gradientTransform="rotate(90)">
                                <stop offset="0%" stopColor="#282F39" />
                                <stop offset="100%" stopColor="#0A9FD7E3" />
                                </linearGradient>
                            </defs>
                        </svg>
                            <CircularProgressbar
                            value={percentage}
                            text={`${percentage}%`}
                            styles={buildStyles({
                                pathColor: 'url(#gradient)', 
                                textColor: '#2F2F3B', 
                                trailColor: '#E5E6EFCC', 
                                strokeWidth: 5, 
                            })}
                            />
                    </div>
                </div>            
                <p className='font-itcbold text-[18px] text-[#2F2F3B] text-end'>5 Horas</p>
                <p className='font-itcbook text-[12px] text-[#2F2F3B] w-[103px]'>Tiempo Promedio</p>
            </div>
        </div>

        <div className="flex mt-3 space-x-32 bg-white p-6 rounded-lg shadow-lg items-center">
            <div className='space-y-2 '>
                <p className='font-itcmedium text-[16px] text-[#2F2F3B]'>Chimbote</p>
                <p className='font-itcmedium text-[22px] text-[#2F2F3B]'>200</p>
                <p className='font-itcmedium text-[12px] text-[#52526CCC] w-[125px]'>Registro de Vehículos</p>
            </div>

            <div className='space-y-1'>
                <div className="flex justify-end items-center ">
                    <div style={{ width: 76, height: 76 }}>
                        <svg style={{ height: 0 }}>
                            <defs>
                                <linearGradient id="gradient" gradientTransform="rotate(90)">
                                <stop offset="0%" stopColor="#282F39" />
                                <stop offset="100%" stopColor="#0A9FD7E3" />
                                </linearGradient>
                            </defs>
                        </svg>
                            <CircularProgressbar
                            value={percentage2}
                            text={`${percentage2}%`}
                            styles={buildStyles({
                                pathColor: 'url(#gradient)', 
                                textColor: '#2F2F3B', 
                                trailColor: '#E5E6EFCC', 
                                strokeWidth: 5,
                            })}
                            />
                    </div>
                </div>            
                <p className='font-itcbold text-[18px] text-[#2F2F3B] text-end'>5 Horas</p>
                <p className='font-itcbook text-[12px] text-[#2F2F3B] w-[103px]'>Tiempo Promedio</p>
            </div>
        </div>

        <div className="flex mt-3 space-x-32 bg-white p-6 rounded-lg shadow-lg items-center">
            <div className='space-y-2 '>
                <p className='font-itcmedium text-[16px] text-[#2F2F3B]'>Vegueta</p>
                <p className='font-itcmedium text-[22px] text-[#2F2F3B]'>210</p>
                <p className='font-itcmedium text-[12px] text-[#52526CCC] w-[125px]'>Registro de Vehículos</p>
            </div>

            <div className='space-y-1'>
                <div className="flex justify-end items-center ">
                    <div style={{ width: 76, height: 76 }}>
                        <svg style={{ height: 0 }}>
                            <defs>
                                <linearGradient id="gradient" gradientTransform="rotate(90)">
                                <stop offset="0%" stopColor="#282F39" />
                                <stop offset="100%" stopColor="#0A9FD7E3" />
                                </linearGradient>
                            </defs>
                        </svg>
                            <CircularProgressbar
                            value={percentage3}
                            text={`${percentage3}%`}
                            styles={buildStyles({
                                pathColor: 'url(#gradient)', 
                                textColor: '#2F2F3B',
                                trailColor: '#E5E6EFCC', 
                                strokeWidth: 5,
                            })}
                            />
                    </div>
                </div>            
                <p className='font-itcbold text-[18px] text-[#2F2F3B] text-end'>8 Horas</p>
                <p className='font-itcbook text-[12px] text-[#2F2F3B] w-[103px]'>Tiempo Promedio</p>
            </div>
        </div>


        <div className="flex mt-3 space-x-32 bg-white p-6 rounded-lg shadow-lg items-center">
            <div className='space-y-2 '>
                <p className='font-itcmedium text-[16px] text-[#2F2F3B]'>Chimbote</p>
                <p className='font-itcmedium text-[22px] text-[#2F2F3B]'>200</p>
                <p className='font-itcmedium text-[12px] text-[#52526CCC] w-[125px]'>Registro de Vehículos</p>
            </div>

            <div className='space-y-1'>
                <div className="flex justify-end items-center ">
                    <div style={{ width: 76, height: 76 }}>
                        <svg style={{ height: 0 }}>
                            <defs>
                                <linearGradient id="gradient" gradientTransform="rotate(90)">
                                <stop offset="0%" stopColor="#282F39" />
                                <stop offset="100%" stopColor="#0A9FD7E3" />
                                </linearGradient>
                            </defs>
                        </svg>
                            <CircularProgressbar
                            value={percentage2}
                            text={`${percentage2}%`}
                            styles={buildStyles({
                                pathColor: 'url(#gradient)', 
                                textColor: '#2F2F3B', 
                                trailColor: '#E5E6EFCC', 
                                strokeWidth: 5, 
                            })}
                            />
                    </div>
                </div>            
                <p className='font-itcbold text-[18px] text-[#2F2F3B] text-end'>5 Horas</p>
                <p className='font-itcbook text-[12px] text-[#2F2F3B] w-[103px]'>Tiempo Promedio</p>
            </div>
        </div>  
    </div>
  );
};

export default ProgressCircle;
